import { Box } from "@mui/material";
import React from "react";

const table_style = {
  width: "100%",
  borderCollapse: "collapse",
  minWidth: 1000,
};

const th_td_style = {
  border: "1px solid black",
  textAlign: "left",
  paddingLeft: 8,
  color: "black",
  fontWeight: "400",
};

const data = [
  {
    isIndex: true,
    title: "A - TÀI SẢN NGẮN HẠN",
    code: 100,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "I. Tiền và các khoản tương đương tiền",
    bold: true,
    code: 110,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Tiền",
    code: 111,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Các khoản tương đương tiền",
    code: 112,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "II. Đầu tư tài chính ngắn hạn",
    bold: true,
    code: 120,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Chứng khoán kinh doanh",
    code: 121,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Dự phòng giảm giá chứng khoán kinh doanh (*)",
    code: 122,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "3. Đầu tư nắm giữ đến ngày đáo hạn",
    code: 123,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "III. Các khoản phải thu ngắn hạn",
    code: 130,
    bold: true,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Phải thu ngắn hạn của khách hàng",
    code: 131,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Trả trước cho người bán ngắn hạn",
    code: 132,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "3. Phải thu nội bộ ngắn hạn",
    code: 133,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "4. Phải thu theo tiến độ kế hoạch hợp đồng xây dựng",
    code: 134,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "5. Phải thu về cho vay ngắn hạn",
    code: 135,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "6. Phải thu ngắn hạn khác",
    code: 136,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "7. Dự phòng phải thu ngắn hạn khó đòi (*)",
    code: 137,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "8. Tài sản thiếu chờ xử lý",
    code: 139,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "IV. Hàng tồn kho",
    code: 140,
    bold: true,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Hàng tồn kho",
    code: 141,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Dự phòng giảm giá hàng tồn kho (*)",
    code: 149,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: true,
    title: "B - TÀI SẢN DÀI HẠN",
    code: 200,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "I. Các khoản phải thu dài hạn",
    code: 210,
    bold: true,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Phải thu dài hạn của khách hàng",
    code: 211,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Trả trước cho người bán dài hạn",
    code: 212,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "3. Vốn kinh doanh ở đơn vị trực thuộc",
    code: 213,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "4. Phải thu nội bộ dài hạn",
    code: 214,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "5. Phải thu về cho vay dài hạn",
    code: 215,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "6. Phải thu dài hạn khác",
    code: 216,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "7. Dự phòng phải thu dài hạn khó đòi (*)",
    code: 219,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "II. Tài sản cố định",
    bold: true,
    code: 220,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Tài sản cố định hữu hình",
    code: 221,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "- Nguyên giá",
    code: 222,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "- Giá trị hao mòn luỹ kế (*)",
    code: 223,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Tài sản cố định thuê tài chính",
    code: 224,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "- Nguyên giá",
    code: 225,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "- Giá trị hao mòn luỹ kế (*)",
    code: 226,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "3. Tài sản cố định vô hình",
    code: 227,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "- Nguyên giá",
    code: 228,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "- Giá trị hao mòn luỹ kế (*)",
    code: 229,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "III. Bất động sản đầu tư",
    code: 230,
    bold: true,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "- Nguyên giá",
    code: 231,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "- Giá trị hao mòn luỹ kế (*)",
    code: 232,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "IV. Tài sản dở dang dài hạn",
    bold: true,
    code: 240,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Chi phí sản xuất, kinh doanh dở dang dài hạn",
    code: 241,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Chi phí xây dựng cơ bản dở dang",
    code: 242,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "V. Đầu tư tài chính dài hạn",
    code: 250,
    bold: true,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Đầu tư vào công ty con",
    code: 251,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Đầu tư vào công ty liên doanh, liên kết",
    code: 252,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "3. Đầu tư góp vốn vào đơn vị khác",
    code: 253,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "4. Dự phòng đầu tư tài chính dài hạn (*)",
    code: 254,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "5. Đầu tư nắm giữ đến ngày đáo hạn",
    code: 255,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "VI. Tài sản dài hạn khác",
    code: 260,
    bold: true,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Chi phí trả trước dài hạn",
    code: 261,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Tài sản thuế thu nhập hoãn lại",
    code: 262,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "3. Thiết bị, vật tư, phụ tùng thay thế dài hạn",
    code: 263,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "4. Tài sản dài hạn khác",
    code: 268,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: true,
    title: "TỔNG CỘNG TÀI SẢN (270 = 100 + 200)",
    code: 270,
    sum: true,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: true,
    title: "C - NỢ PHẢI TRẢ",
    code: 300,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "I. Nợ ngắn hạn",
    code: 310,
    bold: true,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Phải trả người bán ngắn hạn",
    code: 311,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Người mua trả tiền trước ngắn hạn",
    code: 312,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "3. Thuế và các khoản phải nộp Nhà nước",
    code: 313,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "4. Phải trả người lao động",
    code: 314,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "5. Chi phí phải trả ngắn hạn",
    code: 315,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "6. Phải trả nội bộ ngắn hạn",
    code: 316,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "7. Phải trả theo tiến độ kế hoạch hợp đồng xây dựng",
    code: 317,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "8. Doanh thu chưa thực hiện ngắn hạn",
    code: 318,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "9. Phải trả ngắn hạn khác",
    code: 319,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "10. Vay và nợ thuê tài chính ngắn hạn",
    code: 320,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "11. Dự phòng phải trả ngắn hạn",
    code: 321,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "12. Quỹ khen thưởng, phúc lợi",
    code: 322,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "13. Quỹ bình ổn giá",
    code: 323,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "14. Giao dịch mua bán lại trái phiếu Chính phủ",
    code: 324,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "II. Nợ dài hạn",
    code: 330,
    bold: true,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Phải trả người bán dài hạn",
    code: 331,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Người mua trả tiền trước dài hạn",
    code: 332,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "3. Chi phí phải trả dài hạn",
    code: 333,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "4. Phải trả nội bộ về vốn kinh doanh",
    code: 334,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "5. Phải trả nội bộ dài hạn",
    code: 335,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "6. Doanh thu chưa thực hiện dài hạn",
    code: 336,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "7. Phải trả dài hạn khác",
    code: 337,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "8. Vay và nợ thuê tài chính dài hạn",
    code: 338,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "9. Trái phiếu chuyển đổi",
    code: 339,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "10. Cổ phiếu ưu đãi",
    code: 340,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "11. Thuế thu nhập hoãn lại phải trả",
    code: 341,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "12. Dự phòng phải trả dài hạn",
    code: 342,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "13. Quỹ phát triển khoa học và công nghệ",
    code: 343,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: true,
    title: "D - VỐN CHỦ SỞ HỮU",
    code: 400,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "I. Vốn chủ sở hữu",
    code: 410,
    bold: true,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Vốn góp của chủ sở hữu",
    code: 411,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "- Cổ phiếu phổ thông có quyền biểu quyết",
    code: "411a",
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "- Cổ phiếu ưu đãi",
    code: "411b",
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Thặng dư vốn cổ phần",
    code: 412,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "3. Quyền chọn chuyển đổi trái phiếu",
    code: 413,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "4. Vốn khác của chủ sở hữu",
    code: 414,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "5. Cổ phiếu quỹ (*)",
    code: 415,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "6. Chênh lệch đánh giá lại tài sản",
    code: 416,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "7. Chênh lệch tỷ giá hối đoái",
    code: 417,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "8. Quỹ đầu tư phát triển",
    code: 418,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "9. Quỹ hỗ trợ sắp xếp doanh nghiệp",
    code: 419,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "10. Quỹ khác thuộc vốn chủ sở hữu",
    code: 420,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "11. Lợi nhuận sau thuế chưa phân phối",
    code: 421,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "- LNST chưa phân phối lũy kế đến cuối kỳ trước",
    code: "421a",
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "- LNST chưa phân phối kỳ này",
    code: "421b",
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "12. Nguồn vốn đầu tư XDCB",
    code: 422,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "II. Nguồn kinh phí và quỹ khác",
    code: 430,
    bold: true,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "1. Nguồn kinh phí",
    code: 431,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: false,
    title: "2. Nguồn kinh phí đã hình thành TSCĐ",
    code: 432,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
  {
    isIndex: true,
    title: "TỔNG CỘNG TÀI SẢN (440 = 300 + 400)",
    code: 440,
    sum: true,
    present: "",
    valueStartYear: "",
    valueEndYear: "",
  },
];

export default function TableDN() {
  return (
    <Box overflow="auto">
      <h5 style={{ marginBottom: 10 }}>
        Bảng cân đối kế toán năm của doanh nghiệp hoạt động liên tục
      </h5>
      <table style={table_style}>
        <tr>
          <th style={{ ...th_td_style, textAlign: "center", padding: 8 }}>TÀI SẢN</th>
          <th style={{ ...th_td_style, textAlign: "center", padding: 8 }}>Mã số</th>
          <th style={{ ...th_td_style, textAlign: "center", padding: 8 }}>Thuyết minh</th>
          <th style={{ ...th_td_style, textAlign: "center", padding: 8 }}>Số cuối năm (3)</th>
          <th style={{ ...th_td_style, textAlign: "center", padding: 8 }}>Số đầu năm (3)</th>
        </tr>
        <tr>
          <th style={{ ...th_td_style, textAlign: "center" }}>1</th>
          <th style={{ ...th_td_style, textAlign: "center" }}>2</th>
          <th style={{ ...th_td_style, textAlign: "center" }}>3</th>
          <th style={{ ...th_td_style, textAlign: "center" }}>4</th>
          <th style={{ ...th_td_style, textAlign: "center" }}>5</th>
        </tr>
        {data &&
          data.length > 0 &&
          data.map((row, index) => {
            return (
              <tr key={row.title + index} className="table-row">
                <th
                  style={{
                    ...th_td_style,
                    fontSize: 18,
                    textAlign: row.isIndex ? "center" : "left",
                    borderTop: row.isIndex ? "1px solid black" : "none",
                    borderBottom: index === data.length - 1 ? "1px solid black" : "none",
                    fontWeight: row.isIndex || row.bold ? "600" : "400",
                    paddingTop: !row.sum ? (row.isIndex ? 8 : row.bold ? 16 : 0) : 0,
                    paddingLeft: row.isIndex
                      ? 8
                      : row.bold
                      ? 16
                      : row.title?.startsWith("-")
                      ? 40
                      : 24,
                    fontSize: row.isIndex ? 20 : 18,
                  }}
                >
                  {row.title}
                </th>
                <th
                  style={{
                    ...th_td_style,
                    fontSize: 18,
                    textAlign: "center",
                    borderTop: row.isIndex ? "1px solid black" : "none",
                    borderBottom: index === data.length - 1 ? "1px solid black" : "none",
                    fontWeight: row.isIndex || row.bold ? "600" : "400",
                    paddingTop: !row.sum ? (row.isIndex ? 8 : row.bold ? 16 : 0) : 0,
                  }}
                >
                  {row.code}
                </th>
                <th
                  style={{
                    ...th_td_style,
                    fontSize: 18,
                    borderTop: row.isIndex ? "1px solid black" : "none",
                    borderBottom: index === data.length - 1 ? "1px solid black" : "none",
                    paddingTop: !row.sum ? (row.isIndex ? 8 : row.bold ? 16 : 0) : 0,
                  }}
                >
                  {row.present}
                </th>
                <th
                  style={{
                    ...th_td_style,
                    fontSize: 18,
                    borderTop: row.isIndex ? "1px solid black" : "none",
                    borderBottom: index === data.length - 1 ? "1px solid black" : "none",
                    paddingTop: !row.sum ? (row.isIndex ? 8 : row.bold ? 16 : 0) : 0,
                  }}
                >
                  {row.valueStartYear}
                </th>
                <th
                  style={{
                    ...th_td_style,
                    fontSize: 18,
                    borderTop: row.isIndex ? "1px solid black" : "none",
                    borderBottom: index === data.length - 1 ? "1px solid black" : "none",
                    paddingTop: !row.sum ? (row.isIndex ? 8 : row.bold ? 16 : 0) : 0,
                  }}
                >
                  {row.valueEndYear}
                </th>
              </tr>
            );
          })}
      </table>
    </Box>
  );
}
